import { useMutation, useQueryClient } from '@tanstack/react-query';
import { api } from '@/lib/api';
import { useAuthStore } from './store';
import { authKeys } from './queries';

/**
 * Logout mutation — POST /auth/logout.
 *
 * Clears the cookie server-side, then wipes the local cache so any
 * subsequent route immediately reflects the unauthenticated state.
 */
export function useLogout() {
  const queryClient = useQueryClient();
  const clear = useAuthStore((s) => s.clear);

  return useMutation({
    mutationFn: async () => {
      await api.post('/auth/logout');
    },
    onSuccess: () => {
      queryClient.setQueryData(authKeys.me(), null);
      queryClient.clear();
      clear();
    },
  });
}
